<template>
  <div class="app-container">
    <div class="table-container">
      <el-table :data="list" v-loading="listLoading">
        <el-table-column label="Name">
          <template slot-scope="scope">{{ scope.row.name }}</template>
        </el-table-column>
        <el-table-column label="type">
          <template slot-scope="scope"> {{ scope.row.type }} </template>
        </el-table-column>
        <el-table-column label="Product num">
          <template slot-scope="scope"> {{ scope.row.productIds.length }} </template>
        </el-table-column>
        <el-table-column label="Operations">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="editBadge(scope.row.id)">Details/Edit</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import { fetchList } from '@/api/badge';

export default {
  name: 'BadgeTask',
  created() {
    fetchList().then((response) => {
      this.list = response.data;
      this.listLoading = false;
    });
  },
  data() {
    return {
      list: [],
      listLoading: true,
    };
  },
  methods: {
    editBadge(id) {
      this.$router.push({
        path: '/badge/editBadge',
        query: { id },
      });
    },
  },
};
</script>
